import React, { useState, useEffect } from "react";
import Logo from "../../assets/FastRealtyLogo.png";
import DashBoardIcon from "../../assets/dashboardIcon.png";
import SettingsIcon from "../../assets/settings.png";
import myProfileIcon from "../../assets/myProfile.png";
import LogOutIcon from "../../assets/exit.png";
import DownArrowIcon from "../../assets/downArrowIcon.png";
import RightArrow from "../../assets/rightArrow.png";
import { Auth } from "aws-amplify";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToken } from "../../../../actions/addToken";
import { clearHostedUiToken } from "../../../../utils/hostedUiToken";

const AdminSideBar = ({ onClose }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isAdminOpen, setAdminOpen] = useState(false);
  const [isHITLOpen, setHITLOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const signOut = async () => {
    try {
      await Auth.signOut();
      console.log("logout successful");
      localStorage.removeItem("token");
      clearHostedUiToken();
      dispatch(addToken(null));
      history.push("./");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  const handleDashboard = () => {
    history.push("/admin/dashboard");
  };

  const handleLogoClick = () => {
    history.push("/dashboard");
  };

  useEffect(() => {
    // Automatically open section based on current route
    if (
      location.pathname === "/admin/users" ||
      location.pathname === "/admin/invitations" ||
      location.pathname === "/admin/analytics" ||
      location.pathname === "/admin/hitl/deals/all" ||
      location.pathname === "/admin/site-config"
    ) {
      setAdminOpen(true);
    } else if (
      location.pathname === "/admin/hitl/zillow" ||
      location.pathname === "/admin/hitl/deals" ||
      location.pathname === "/admin/hitl/inbound"
    ) {
      setHITLOpen(true);
    }
  }, [location.pathname]);

  const activeStyle = {
    color: "#28a382",
    borderLeft: "3px solid #28a382",
    backgroundColor: "#f9f9f9",
  };

  return (
    <div className="sideBar-container">
      <div className="sideBar-top">
        <div className="sideBar-logo">
          <img src={Logo} alt="logo" className="sb-logo" onClick={handleLogoClick} style={{ cursor: "pointer" }} />
          <img
            src={RightArrow}
            alt="right-arrow"
            className="right-arrow"
            onClick={onClose}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="sideBar-content-container">
          {/* Dashboard */}
          <div
            className="dashboard-s"
            style={location.pathname === "/admin/dashboard" ? activeStyle : {}}
            onClick={handleDashboard}
          >
            <div className="ds">
              <img
                src={DashBoardIcon}
                alt="dashboard-icon"
                className="dashboard-icon"
              />
              <p>Admin Dashboard</p>
            </div>
          </div>

          {/* Admin Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={
                location.pathname === "/admin/users" ||
                location.pathname === "/admin/invitations" ||
                location.pathname === "/admin/analytics" ||
                location.pathname === "/admin/hitl/deals/all" ||
                location.pathname === "/admin/site-config"
                  ? activeStyle
                  : {}
              }
              onClick={() => setAdminOpen(!isAdminOpen)}
            >
              <div className="prospector-s-ls">
                <img
                  src={SettingsIcon}
                  alt="admin-icon"
                  className="prospector-icon"
                />
                <p>Admin</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isAdminOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {(isAdminOpen ||
              location.pathname === "/admin/users" ||
              location.pathname === "/admin/invitations" ||
              location.pathname === "/admin/analytics" ||
              location.pathname === "/admin/hitl/deals/all" ||
              location.pathname === "/admin/site-config") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={isActive("/admin/users") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setAdminOpen(true);
                    history.push("/admin/users");
                  }}
                >
                  User Management
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/invitations") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setAdminOpen(true);
                    history.push("/admin/invitations");
                  }}
                >
                  Invitations
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/analytics") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setAdminOpen(true);
                    history.push("/admin/analytics");
                  }}
                >
                  Analytics
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/hitl/deals/all") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setAdminOpen(true);
                    history.push("/admin/hitl/deals/all");
                  }}
                >
                  All Deals
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/site-config") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setAdminOpen(true);
                    history.push("/admin/site-config");
                  }}
                >
                  Site Configuration
                </p>
              </div>
            )}
          </div>

          {/* Human In The Loop Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={
                location.pathname === "/admin/hitl/zillow" ||
                location.pathname === "/admin/hitl/deals" ||
                location.pathname === "/admin/hitl/inbound"
                  ? activeStyle
                  : {}
              }
              onClick={() => setHITLOpen(!isHITLOpen)}
            >
              <div className="prospector-s-ls">
                <img
                  src={SettingsIcon}
                  alt="hitl-icon"
                  className="prospector-icon"
                />
                <p>Human In The Loop</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isHITLOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {(isHITLOpen ||
              location.pathname === "/admin/hitl/zillow" ||
              location.pathname === "/admin/hitl/deals" ||
              location.pathname === "/admin/hitl/inbound") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={isActive("/admin/hitl/zillow") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setHITLOpen(true);
                    history.push("/admin/hitl/zillow");
                  }}
                >
                  Zillow Listing
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/hitl/deals") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setHITLOpen(true);
                    history.push("/admin/hitl/deals");
                  }}
                >
                  Email Approvals
                </p>
                <p
                  className="hidden-li"
                  style={isActive("/admin/hitl/inbound") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setHITLOpen(true);
                    history.push("/admin/hitl/inbound");
                  }}
                >
                  Inbound Review
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="sideBar-bottom">
        <div className="sideBar-sp">
          <div
            className="profile"
            style={location.pathname === "/myaccount" ? activeStyle : {}}
            onClick={() => history.push("/myaccount")}
          >
            <img src={myProfileIcon} alt="profile" className="profile-icon" />
            <p>My Profile</p>
          </div>
        </div>
        <div className="lg" onClick={signOut}>
          <img src={LogOutIcon} alt="logOutIcon" className="logOut-icon" />
          <p>LogOut</p>
        </div>
      </div>
    </div>
  );
};

export default AdminSideBar;